// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal-overlay_overlay__1PmjF","hidden":"modal-overlay_hidden__1gr4a"};